export const GET_LEADS_LAST_ACTION_SUCCESS = 'GET_LEADS_LAST_ACTION_SUCCESS'
export const SET_FETCHING_LEADS_LAST_ACTION = 'SET_FETCHING_LEADS_LAST_ACTION'
export const SET_LEADS_LAST_ACTION_FILTERS = 'SET_LEADS_LAST_ACTION_FILTERS'
export const RESET_LEADS_LAST_ACTION_FILTERS = 'RESET_LEADS_LAST_ACTION_FILTERS'
